import type { FieldDef } from "@/components/wizard/field-list";

export interface Draft {
	name?: string;
	birth_date?: string;
	cpf?: string;
	rg?: string;
	mother_name?: string;
	phone?: string;
	email?: string;
	preferred_channel?: string;
	cep?: string;
	address_number?: string;
	address_complement?: string;
	occupation?: string;
	marital_status?: string;
	has_insurance?: string;
	insurance?: string;
	how_found?: string;
	how_found_other?: string;
	photo?: string;
}

export type FieldKind =
	| "text"
	| "tel"
	| "email"
	| "cpf"
	| "date"
	| "cep"
	| "choice"
	| "boolean"
	| "photo";

export interface FichaField extends FieldDef<Draft, FieldKind> {
	short: string;
	options?: string[];
}

export const BOOLEAN_YES = "sim";
export const BOOLEAN_NO = "nao";
export const HOW_FOUND_OTHER = "Outro";

const CHANNELS = ["WhatsApp", "Ligação", "E-mail", "SMS"];
const MARITAL = ["Solteiro(a)", "Casado(a)", "Divorciado(a)", "Viúvo(a)", "União estável"];
const HOW_FOUND = ["Indicação de amigo", "Instagram", "Google", HOW_FOUND_OTHER];

export const FIELDS: FichaField[] = [
	{ key: "name", label: "Qual é o seu nome completo?", short: "Nome", kind: "text" },
	{ key: "birth_date", label: "Sua data de nascimento", short: "Nascimento", kind: "date" },
	{ key: "cpf", label: "Seu CPF", short: "CPF", kind: "cpf" },
	{ key: "rg", label: "E o seu RG", short: "RG", kind: "text" },
	{ key: "mother_name", label: "Nome completo da sua mãe", short: "Nome da mãe", kind: "text" },
	{ key: "phone", label: "Um telefone com WhatsApp", short: "Telefone", kind: "tel" },
	{ key: "email", label: "Seu melhor e-mail", short: "E-mail", kind: "email" },
	{
		key: "preferred_channel",
		label: "Como você prefere que a gente fale com você?",
		short: "Contato",
		kind: "choice",
		options: CHANNELS,
	},
	{
		key: "cep",
		label: "Seu CEP",
		short: "CEP",
		kind: "cep",
		hint: "A gente completa o resto do endereço pra você",
	},
	{ key: "address_number", label: "Número", short: "Número", kind: "text" },
	{
		key: "address_complement",
		label: "Complemento",
		short: "Complemento",
		kind: "text",
		optional: true,
	},
	{ key: "occupation", label: "Qual a sua profissão?", short: "Profissão", kind: "text" },
	{
		key: "marital_status",
		label: "Estado civil",
		short: "Estado civil",
		kind: "choice",
		options: MARITAL,
	},
	{
		key: "has_insurance",
		label: "Você tem plano de saúde?",
		short: "Plano de saúde",
		kind: "boolean",
	},
	{
		key: "insurance",
		label: "Qual plano?",
		short: "Qual plano",
		kind: "text",
		condition: (d) => d.has_insurance === BOOLEAN_YES,
	},
	{
		key: "how_found",
		label: "Como você chegou até a gente?",
		short: "Como conheceu",
		kind: "choice",
		options: HOW_FOUND,
		optional: true,
	},
	{
		key: "how_found_other",
		label: "Conta pra gente como nos conheceu",
		short: "De onde nos conhece",
		kind: "text",
		optional: true,
		condition: (d) => d.how_found === HOW_FOUND_OTHER,
	},
	{
		key: "photo",
		label: "Uma foto sua",
		short: "Foto",
		kind: "photo",
		hint: "Foto obrigatória para identificação na recepção",
	},
];
